export default {
    all: (state) => {
        return state.logs
    },
    count: (state) => {
        return state.logs.length
    },
    isEnabled: (state) => {
        return state.isEnabled
    },
    maxLogs: (state) => {
        return state.maxLogs
    }
}
